"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "neviano-degli-arduini": {
    "289191ec": [{
      "hkey": "e593fd68",
      "slug": "antreola-mizone",
      "name": "Antreola-Mizone",
      "primary": true,
      "skipSearch": false
    }],
    "antreola": [{
      "hkey": "e593fd68",
      "slug": "antreola-mizone",
      "name": "Antreola-Mizone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "18e72d4d": [{
      "hkey": "6fbff837",
      "slug": "neviano-degli-arduini",
      "name": "Neviano degli Arduini",
      "primary": true,
      "skipSearch": false
    }],
    "villa-s-s-giovanni-e-paolo": [{
      "hkey": "6fbff837",
      "slug": "neviano-degli-arduini",
      "name": "Neviano degli Arduini",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;